import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { InfoOutline } from '@lyearn/icons';
import { Box, Stack, Switch, Tooltip, Typography } from '@lyearn/ui';

import { TertiaryActionProps } from './types';

const TertiaryAction: React.FC<TertiaryActionProps> = (props) => {
  const { t } = useTranslation('LyearnConnect');
  const { onChange, allowDuplication } = props;

  return (
    <Stack alignItems="center" className="ps-16">
      <Switch checked={allowDuplication} onChange={onChange} />
      <Typography className="ms-12" color="text-text-secondary" variant="body-short-01">
        {t('LyearnConnect:AllowDuplication.Label')}
      </Typography>
      <Tooltip
        className="ms-4"
        placement="top"
        title={`${t('LyearnConnect:AllowDuplication.Tooltip')}`}>
        <Box>
          <InfoOutline
            className="text-icon-secondary hover:text-icon-primary"
            height="18"
            width="18"
          />
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default TertiaryAction;
